import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getUserPaymentMethods } from "@modules/PaymentProcessing/services/paymentMethods";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";

export const useUserPaymentMethods = () => {
  const {
    data: paymentMethods,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery("userPaymentMethods", () =>
    getUserPaymentMethods().then(({ data }) => data)
  );

  const getPreferredCreditCard = () => {
    let creditCard;
    if (paymentMethods?.length > 0) {
      creditCard = paymentMethods
        .sort((pm) => (pm.preferred ? -1 : 1))
        .find((pm) => pm.method === PaymentMethodType.CREDIT_CARD);
    }
    return creditCard;
  };

  return {
    paymentMethods,
    isLoading,
    isError,
    isSuccess,
    status,
    getPreferredCreditCard,
  };
};
